export var BUTTON_SHAPES = Object.freeze({
  circle: 'circle',
  square: 'square'
});